import React, { useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";
import { Link } from "react-router-dom";

const PlanPage = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const tenantId = "T1111001XT7";
  const [showMember, setShowMember] = useState(false);

  const [isRider, setIsRider] = useState(false);

  return (
    <main>
      {/* breadcrumb start */}
      <section
        className="page-title mt-[80px]"
        style={{
          backgroundImage: "url(assets/images/inner/page-title-bg.jpg)",
        }}
      >
        <div className="auto-container">
          <div className="title-outer">
            <ul className="page-breadcrumb wow fadeInUp" data-wow-delay=".3s">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Plans</li>
            </ul>
            <h1 className="title wow fadeInUp" data-wow-delay=".5s">
              Plans
            </h1>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* plan pricing starts */}
      <section className="pricing-section fix section-padding pt-[80px]">
        <div className="auto-container">
          <div className="tab-content">
            <div id="Monthly" className="tab-pane fade show active">
              <div className="row">
                <div
                  className="col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="pricing-box-items common">
                    <div className="pricing-header">
                      <h3 className="font-bold mb-[20px]">Personal Plan</h3>
                      <div className="flex items-baseline gap-[10px]">
                        <div className="text-[48px] text-[#7217ff] font-semibold">
                          ₹ 2000
                        </div>
                        <div className="text-[16px] text-[#000000] font-semibold">
                          + GST
                        </div>
                      </div>
                    </div>
                    <ul className="pricing-list pb-[25px]">
                      <li>
                        <div className="icon">
                          <i className="fa-solid fa-check" />
                        </div>
                        <span>
                          <strong>2 Calls / Month </strong> Tele Doctor
                          Consultation
                        </span>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="fa-solid fa-check" />
                        </div>
                        <span>
                          <strong>Upto 50% off on 1 credit </strong> Full Body
                          Checkup (91 parameters)
                        </span>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="fa-solid fa-check" />
                        </div>
                        <span>
                          <strong>Upto 20% off on Rs 25,000 </strong> Pharmacy -
                          Prescribed Medicines
                        </span>
                      </li>
                    </ul>

                    <ul className="pricing-list">
                      <div className="text-[20px] font-semibold pb-[20px]">
                        Platform Benefits
                      </div>
                      <li>
                        <div className="icon">
                          <i className="fa-solid fa-check" />
                        </div>
                        <span>
                          <strong>Upto 50% off </strong> on Diagnostic &
                          Radiology
                        </span>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="fa-solid fa-check" />
                        </div>
                        <span>
                          <strong>Upto 20% off </strong> on Prescribed Medicines
                        </span>
                      </li>

                      <div
                        to=""
                        className="theme-btn btn-style-one cursor-pointer mt-[40px] mb-[60px] wow fadeInUp"
                        data-wow-delay=".5s"
                        onClick={() => {
                          setPlanCode("ZealthixDummyPlan");
                          setShowMember(true)
                          setOpenPopup(true);
                          setIsRider(true)
                        }}
                      >
                        Buy Plan
                        <span className="icon">
                          <i className="flaticon-finance-arrow-right-svgrepo-com1-2" />
                        </span>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* plan pricing ends */}

      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        showMember={showMember}
        isRider={isRider}
      />
    </main>
  );
};

export default PlanPage;
